import { render, staticRenderFns } from "./RegistrationGiveaway.vue?vue&type=template&id=04f3c7b8&lang=pug&"
import script from "./RegistrationGiveaway.vue?vue&type=script&lang=ts&"
export * from "./RegistrationGiveaway.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports